import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from 'src/app/shared/shared.module';
import { AsideComponent } from './aside/aside.component';
import { HeaderComponent } from './header/header.component';
import { UserMenuComponent } from './header/user-menu.component';
import { LayoutComponent } from './layout.component';
import { SplashComponent } from './splash/splash.component';

/**
 * O shell próprio da onda C3 — Angular Material + CDK, sem Metronic.
 *
 * O que NÃO entra aqui, e é o ponto: `ngx-om-perfect-scrollbar`,
 * `@ng-bootstrap/ng-bootstrap`, o seletor de período de terceiro, `InlineSVGModule`
 * e o `CoreModule` da árvore vendorizada do tema — todos importados pelo
 * `ThemeModule`, todos na lista de deleção da C3 item 6. Nenhum dos cinco
 * `scripts` globais do `angular.json` é alcançado por este código.
 *
 * (O nome da pasta do tema não é escrito aqui de propósito: o portão P1 conta o
 * literal em arquivo de produção, e citá-lo num comentário reprova a suíte.)
 *
 * `SharedModule` entrava por um componente só, o selo de ambiente — removido em
 * 31/08/2026. O import continua porque tirá-lo é limpeza à parte, com risco
 * próprio; se ninguém mais o consumir aqui, ele deve sair.
 */
@NgModule({
  exports: [LayoutComponent, SplashComponent],
  imports: [
    CommonModule,
    RouterModule,
    A11yModule,
    ScrollingModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxPermissionsModule.forChild(),
    SharedModule,
    LayoutComponent,
    AsideComponent,
    HeaderComponent,
    UserMenuComponent,
    SplashComponent,
  ],
})
export class LayoutModule {}
